import React, { useState, useContext } from "react";
import { AppContext } from "../../components/States/AppContext";

import styled from "styled-components/macro";
import lockscrn from "../../img/misc/lockscrn.png";

import { Link, useNavigate } from "react-router-dom";

//styles
import {
  GrayBox,
  InputBox,
  LockBoxOverlay,
  NumberContainer,
  Title,
  UnlockContentBox,
  WrongPwAlert,
} from "./Unlock.elements";

//icons
import { FaBackspace } from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import enterIcon from "../../img/icons/enterarrow2.png";

const LockScreen = styled.img`
  top: 0;
  width: 100%
  height: 100%;
  position: absolute;


`;

const Lock = () => {
  const { state, setState } = useContext(AppContext);

  // setState((prevState) => ({...prevState, isLocked: true}))

  return (
    <>
      {/* <ScreenTest>
        <LockScreen src={lockscrn} />
      </ScreenTest> */}

      <LockScreen src={lockscrn} />
    </>
  );
};

const Unlock = () => {
  const { state, setState } = useContext(AppContext);

  const [password, setPassword] = useState("");
  const [passwordWrong, setPasswordWrong] = useState("");

  const handleChange = (event) => {
    setPassword(event.target.value);
  };

  const handleNumberClick = (number) => {
    setPassword((prevPassword) => prevPassword + number);
    passwordWrong && setPasswordWrong(false);
  };

  const handleBackspace = () => {
    setPassword((prevPassword) => prevPassword.slice(0, -1));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Check the password validity
    if (password === "654321") {
      setState((prevState) => ({
        ...prevState,
        isLockEnterPw: false,
        currentPageIndex: 0,
        isLocked: false,
        isButtonPressed:false,
      }));
    } else {
      setPasswordWrong(true);
      setPassword("");
    }
  };

  const backtoMainScreen1 = () => {
    setState((prevState) => ({
      ...prevState,
      isLockEnterPw: false,
      currentPageIndex: 0,
      isLocked: true,
      isButtonPressed:false,
    }));
  };

  return (
    <GrayBox>
      <LockBoxOverlay />
      <UnlockContentBox>
        <form onSubmit={handleSubmit}>
          <Title>Enter Pin</Title>

          {/* <Link to="/"
          
          style={{ position: "absolute", top: "30%", right: "-1%" }
          
          }>
            <AiOutlineClose
              style={{ color: "#caceca", fontSize: "1.75em" }}
            ></AiOutlineClose>
          </Link> */}
          <div
            onClick={backtoMainScreen1}
            to="/"
            style={{ position: "absolute", top: "30%", right: "-1%" }}
          >
            <AiOutlineClose
              style={{ color: "#caceca", fontSize: "1.75em" }}
            ></AiOutlineClose>
          </div>

          <InputBox
            type="password"
            value={password}
            onChange={handleChange}
            wrongPw={passwordWrong}
          />

          {passwordWrong && <WrongPwAlert>! Re-Enter</WrongPwAlert>}

          <NumberContainer>
            <button onClick={() => handleNumberClick("1")} type="button">
              1
            </button>
            <button onClick={() => handleNumberClick("2")} type="button">
              2
            </button>
            <button onClick={() => handleNumberClick("3")} type="button">
              3
            </button>
            <button onClick={() => handleNumberClick("4")} type="button">
              4
            </button>
            <button onClick={() => handleNumberClick("5")} type="button">
              5
            </button>
            <button onClick={() => handleNumberClick("6")} type="button">
              6
            </button>
            <button onClick={() => handleNumberClick("7")} type="button">
              7
            </button>
            <button onClick={() => handleNumberClick("8")} type="button">
              8
            </button>
            <button onClick={() => handleNumberClick("9")} type="button">
              9
            </button>
            <button
              onClick={handleBackspace}
              className="backspace"
              type="button"
            >
              <FaBackspace style={{ fontSize: "1.35rem", marginTop: ".1em" }} />
            </button>
            <button onClick={() => handleNumberClick("0")} type="button">
              0
            </button>
            <button onClick={handleSubmit} className="enter">
              <img
                src={enterIcon}
                alt=""
                style={{
                  objectFit: "contain",
                  maxHeight: "20px",
                  maxWidth: "35px",
                  margin: "auto",
                }}
              />
            </button>
          </NumberContainer>

          {/* <div className="number-row"></div>
          <div className="number-row"></div>
          <div className="number-row"></div>
          <div className="control-row"></div> */}
        </form>
      </UnlockContentBox>
    </GrayBox>
  );
};

const LockScreenPages = [Lock, Unlock];
export default LockScreenPages;
